import axios from 'axios'
import { clearAuthCache } from '@/utils/auth'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '', // 后端接口基础路径
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器：添加 token
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器：统一处理响应
service.interceptors.response.use(
  response => {
    // 业务状态码 0 表示成功（根据后端约定调整）
    return response.data
  },
  error => {
    console.error('响应错误:', error)
    const { status } = error.response || {}
    switch (status) {
      case 401:
        alert('未授权，请重新登录')
        localStorage.removeItem('token')
        clearAuthCache()
        window.location.href = '#/login'
        break
      case 403:
        alert('权限不足')
        break
      case 500:
        alert('服务器内部错误')
        break
      default:
        alert(error.response?.data?.message || '网络错误')
    }
    return Promise.reject(error)
  }
)

export default service